import { FaInstagram, FaTelegram, FaTwitter } from "react-icons/fa";

export const headerLinks = [
  {
    text: "Ecosystem",
    link: "#ecosystem",
  },
  {
    text: "Tokenomics",
    link: "#tokenomics",
  },
  {
    text: "How To Buy",
    link: "#how-to-buy",
  },
  {
    text: "Road Map",
    link: "#roadmap",
  },
  {
    text: "Stake",
    link: "https://stake.kingstoken.co/",
  },
];

export const socialLinks = [
  // {
  //   icon: <FaInstagram />,
  //   link: "",
  // },

  {
    icon: <FaTelegram />,
    link: "https://t.me/KingsCoinPortal",
  },
  {
    icon: <FaTwitter />,
    link: "https://twitter.com/kingsclantoken",
  },
];
